(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/ticker-winners/assets/javascripts/ticker-winners.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/ticker-winners/assets/javascripts/ticker-winners.js');
"use strict";

const {
  Ticker
} = svs.bingo_react.components;
const {
  winnersFeed,
  cmsGames
} = svs.bingo_react.data;
const {
  BingoLetters
} = svs.bingo_react.components;
const {
  BingoLogotypeLetters
} = svs.bingo_react.components.common.constants;
const {
  showTickerPromoText
} = svs.bingo_react.data.tickerTextConfig;
const startBingoGame = svs.bingo_react.components.startBingoGame;
const {
  useSocket
} = svs.components.lbUtils.socket;
const {
  useCallback,
  useState
} = React;
const TickerWinners = () => {
  const [currentWinners, setCurrentWinners] = useState(winnersFeed);
  const onSocketUpdate = useCallback(data => {
    var _data$winnerFeed$item, _data$winnerFeed;
    setCurrentWinners((_data$winnerFeed$item = data === null || data === void 0 || (_data$winnerFeed = data.winnerFeed) === null || _data$winnerFeed === void 0 ? void 0 : _data$winnerFeed.items) !== null && _data$winnerFeed$item !== void 0 ? _data$winnerFeed$item : []);
  }, []);
  useSocket('/casino/1/winnerfeed/bingo', onSocketUpdate);
  if (!currentWinners.length || currentWinners.length < 5 || showTickerPromoText) {
    return null;
  }
  return React.createElement(Ticker, null, React.createElement("span", null, "Vinnare!"), currentWinners.map((winner, index) => {
    const letter = BingoLogotypeLetters[index];
    const playableGame = cmsGames.find(game => game.id === winner.game.level3);
    return (
      React.createElement("div", {
        className: "bingo-scroller-container__scroller-content__item",
        key: "".concat(winner.game.level3, "-").concat(index)
      }, React.createElement(BingoLetters, {
        letters: [letter]
      }), React.createElement("span", {
        className: playableGame && 'bingo-scroller-container__scroller-content__cursor-pointer',
        onClick: playableGame ? () => startBingoGame(playableGame.id) : undefined
      }, "".concat(winner.amountSek, " kr vinst i ").concat(playableGame ? playableGame.title : winner.game.name)))
    );
  }));
};
setGlobal('svs.bingo_react.components.TickerWinners', TickerWinners);

 })(window);